/* eslint-disable max-lines */
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import userTypeMap from 'utils/usersListMap';

const UsersListFilters: React.FC = () => {
  const route = useRouteMatch();
  const userType = Object.entries(userTypeMap).find(
    ([k]) => route.path.split('/').pop() === k
  )?.[1];

  if (!userType) return null;

  return (
    <div className="flex flex-row justify-between">{React.createElement(userType.filters)}</div>
  );
};

export default UsersListFilters;
